import CryptoJS from 'crypto-js';

export function generateHmac(requestId: string, method?: string): string;

export function generateHmac(options: { type: 'body'; body: object }): string;

export function generateHmac(
  arg: string | { type: 'body'; body: object },
  method: string = 'POST',
): string {
  if (typeof arg === 'object' && arg.type === 'body') {
    const key = process.env.REACT_APP_FEEDBACK_SECRET_KEY;
    if (!key) throw new Error('REACT_APP_FEEDBACK_SECRET_KEY is not set');

    return CryptoJS.HmacSHA256(JSON.stringify(arg.body), key).toString(
      CryptoJS.enc.Hex,
    );
  }

  const key = process.env.REACT_APP_HMAC_SECRET;
  if (!key) throw new Error('REACT_APP_HMAC_SECRET is not set');

  return CryptoJS.HmacSHA256(`${method}|${arg}`, key).toString(
    CryptoJS.enc.Hex,
  );
}
